import {
    UNION_LIST_PARTNER_SUCESS,
    UNION_LIST_PARTNER_FAILED,
    RESET_UNION_LIST_PARTNER,
    LOADING_UNION_LIST_PARTNER,
    NETWORK_ERROR_UNION_LIST_PARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_UNION_LIST_PARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case UNION_LIST_PARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case UNION_LIST_PARTNER_SUCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_UNION_LIST_PARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_UNION_LIST_PARTNER:
            return (state = initialState);
        default:
            return state;
    }
};
